import React, { useEffect } from 'react'
import './Events.css'
import image1 from './images/event1.jpg'
import image2 from './images/event2.jpg'
import image3 from './images/event3.avif'
import image4 from './images/event4.jpg'
import { Link } from 'react-router-dom';

import AOS from 'aos';
import 'aos/dist/aos.css';

const Events = () => {

    useEffect(() => {
        AOS.init();
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top of the page
    }, []);

    return (

        <>

            <div className="floating-icons">
                <a className="icon" href='https://www.facebook.com/login.php/' target='_blank'>
                    <button

                        className="sm_icon"
                    >
                        <img src='https://res.cloudinary.com/dprcylred/image/upload/v1737780082/em6rzkumkpu9thoz7xyi.png' alt="facebook" />
                    </button>
                </a>
                <a className="icon" href='https://www.instagram.com/hamotechsd/' target='_blank'>
                    <button className="sm_icon">
                        <img
                            src='https://res.cloudinary.com/dprcylred/image/upload/v1737780083/cqpiobs4yhxfbs9eneg4.png' alt="instagram" />
                    </button>
                </a>
                <a className="icon" href='https://www.linkedin.com/company/105967594/admin/page-posts/published/' target='_blank'>
                    <button className="sm_icon">
                        <img
                            src='https://res.cloudinary.com/dprcylred/image/upload/v1737780082/btlz8e3ziogli6p2blkh.png' alt="linkedin" />
                    </button>
                </a>
                <a className="icon" href="https://wa.me/+918688964015" target="_blank">
                    <button className="sm_icon">
                        <img
                            src='https://res.cloudinary.com/dprcylred/image/upload/v1737780217/eauw0ts2blhbrycxk1mk.png' alt="whatsapp" />
                    </button>
                </a>
            </div>


            <div className='events_section' style={{ marginTop: "100px" }}>
                <div className='container-fluid'>
                    <div className='events_section_heads'>
                        <h1 style={{ color: "#e65753" }}>Future Occasions</h1>
                        <p style={{ textAlign: "justify" }}>At <span style={{ color: "#e65753" }} data-aos="fade-up" data-aos-duration="1500">Hamo Tech</span>, we are constantly planning and organizing exciting events, workshops, and training sessions to help you stay at the forefront of the tech industry. Here’s a sneak peek at some of our upcoming occasions</p>
                        <p style={{ textAlign: "justify" }}>At <span style={{ color: "#e65753" }} data-aos="fade-up" data-aos-duration="1500">Hamo Tech</span>, we believe in staying ahead of the curve by continuously exploring new horizons in education and innovation. Our upcoming occasions are designed to inspire, educate, and connect aspiring tech professionals with industry leaders. From advanced training workshops and live hackathons to thought-provoking seminars on emerging technologies like AI, quantum computing, and cybersecurity, every event is crafted to empower participants with cutting-edge knowledge and hands-on experience. These gatherings are more than just learning opportunities; they are a platform for networking and collaboration, fostering a community of tech enthusiasts driven by curiosity and ambition.</p>
                    </div>

                    <div className='row mt-5' data-aos="fade-up" data-aos-duration="2000">
                        <div className='col-lg-6 events_section_bg'>

                        </div>
                        <div className='col-lg-6 events_section_mbg'>
                            <img src={image1} className='img-fluid' />
                        </div>
                        <div className='col-lg-6 events_section_content'>
                            <div className='card' >
                                <div data-aos="zoom-in" data-aos-duration="1500">
                                    <h3>Advanced React & Redux Masterclass</h3>
                                    <div className='events_section_content1'>
                                        {/* <p><span><i class="ri-calendar-line"></i></span>January 10, 2025</p>
                                        <p><span><i class="ri-time-line"></i></span>10:00 AM - 5:00 PM</p> */}
                                        <p><span><i class="ri-map-pin-line"></i></span> Online & In-Person (Hybrid)</p>
                                    </div>
                                    <hr />
                                    <div className='events_section_content2'>
                                        <p style={{ textAlign: "justify" }}>
                                            Master advanced React and Redux techniques in this exclusive masterclass. Learn how to handle complex state management, optimize application performance, and create scalable apps using best practices. This event is perfect for intermediate to advanced React developers.
                                        </p>
                                    </div>
                                    <div className='events_section_buttons'>
                                        <Link to="/contact-us"> <button className='events_section_button1'><span><i class="ri-chat-check-fill"></i></span>BOOK NOW</button></Link>
                                        <Link to="/contact-us"><button className='events_section_button2'><span><i class="ri-coupon-fill"></i></span>25 AVAILABLE</button></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row mt-5 card_2'>
                        <div className='col-md-6' data-aos="fade-up" data-aos-duration="1000">
                            <img src={image2} className='img-fluid' />

                            <div className='card' >
                                <div data-aos="zoom-in" data-aos-duration="1500">
                                    <h3>Node.js Backend Development Bootcamp</h3>
                                    <div className='events_section_content1'>
                                        {/* <p><span><i class="ri-calendar-line"></i></span> January 20, 2025</p>
                                        <p><span><i class="ri-time-line"></i></span>9:00 AM - 4:00 PM</p> */}
                                        <p><span><i class="ri-map-pin-line"></i></span> Hamo Tech Institute, Main Campus</p>
                                    </div>
                                    <hr />
                                    <div className='events_section_content2'>
                                        <p style={{ textAlign: "justify" }}>
                                            Dive deep into backend development with Node.js. In this full-day session, you'll learn how to build RESTful APIs, work with databases, and deploy your applications. This bootcamp is ideal for those with basic JavaScript knowledge looking to advance their backend skills.
                                        </p>
                                    </div>
                                    <div className='events_section_buttons'>
                                        <Link to="/contact-us"> <button className='events_section_button1'><span><i class="ri-chat-check-fill"></i></span>BOOK NOW</button></Link>
                                        <Link to="/contact-us"><button className='events_section_button2'><span><i class="ri-coupon-fill"></i></span>20 AVAILABLE</button></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6' data-aos="fade-up" data-aos-duration="2000">
                            <img src={image3} className='img-fluid' />

                            <div className='card'>
                                <div data-aos="zoom-in" data-aos-duration="1500">
                                    <h3>AI & Machine Learning Training Program</h3>
                                    <div className='events_section_content1'>
                                        {/* <p><span><i class="ri-calendar-line"></i></span>February 5, 2025</p>
                                        <p><span><i class="ri-time-line"></i></span>10:00 AM - 5:00 PM</p> */}
                                        <p><span><i class="ri-map-pin-line"></i></span> Online</p>
                                    </div>
                                    <hr />
                                    <div className='events_section_content2'>
                                        <p style={{ textAlign: "justify" }}>
                                            Unlock the power of AI and Machine Learning in this comprehensive training program. From data preprocessing to building predictive models, this session will give you the foundational knowledge needed to get started in AI development.
                                        </p>
                                    </div>
                                    <div className='events_section_buttons'>
                                        <Link to="/contact-us"> <button className='events_section_button1'><span><i class="ri-chat-check-fill"></i></span>BOOK NOW</button></Link>
                                        <Link to="/contact-us"><button className='events_section_button2'><span><i class="ri-coupon-fill"></i></span>32 AVAILABLE</button></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='row mt-5' data-aos="fade-up" data-aos-duration="2000">
                        <div className='col-lg-6 events_section4_bg'>

                        </div>
                        <div className='col-lg-6 events_section4_mbg'>
                            <img src={image4} className='img-fluid' />
                        </div>
                        <div className='col-lg-6 events_section_content'>
                            <div className='card' >
                                <div data-aos="zoom-in" data-aos-duration="1500">
                                    <h3>Java Full Stack Developer Program</h3>
                                    <div className='events_section_content1'>
                                        {/* <p><span><i class="ri-calendar-line"></i></span>March 1, 2025</p>
                                        <p><span><i class="ri-time-line"></i></span>10:00 AM - 4:00 PM</p> */}
                                        <p><span><i class="ri-map-pin-line"></i></span> Online</p>
                                    </div>
                                    <hr />
                                    <div className='events_section_content2'>
                                        <p style={{ textAlign: "justify" }}>
                                            Join us for a deep dive into Java Full Stack Development, covering both front-end and back-end technologies. This program is ideal for developers who want to transition into full-stack development and learn how to integrate Java with modern frameworks.
                                        </p>
                                    </div>
                                    <div className='events_section_buttons'>
                                        <Link to="/contact-us"> <button className='events_section_button1'><span><i class="ri-chat-check-fill"></i></span>BOOK NOW</button></Link>
                                        <Link to="/contact-us"><button className='events_section_button2'><span><i class="ri-coupon-fill"></i></span>12 AVAILABLE</button></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>

        </>
    )
}

export default Events
